(function () {
    'use strict';

    $('.mol-inline-search form').on('submit', function (e) {
        return $(this).find('input[type="search"]').val().trim() !== '';
    });
})();
